import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { api } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [devToken, setDevToken] = useState('');
  const [stage, setStage] = useState(1);

  const request = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post('/auth/password-reset/request', { email });
      if (r.data.dev_token) setDevToken(r.data.dev_token);
      toast.success('If the email exists, a reset link was sent.');
      setStage(2);
    } catch (err) { toast.error('Failed'); }
  };

  const confirm = async (e) => {
    e.preventDefault();
    try {
      await api.post('/auth/password-reset/confirm', { token, new_password: newPassword });
      toast.success('Password updated. Please sign in.');
      setStage(3);
    } catch (err) { toast.error(err.response?.data?.detail || 'Invalid token'); }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center py-16 px-4">
      <div className="w-full max-w-md">
        <Card className="bg-white">
          <CardContent className="p-8">
            <h1 className="font-serif text-2xl text-[hsl(var(--brand-navy-2))]">Reset password</h1>
            {stage === 1 && (
              <form onSubmit={request} className="mt-6 space-y-4">
                <div><Label>{t('auth.email')}</Label><Input required type="email" value={email} onChange={e => setEmail(e.target.value)} /></div>
                <Button type="submit" className="w-full bg-[hsl(var(--brand-navy))]">Send reset link</Button>
              </form>
            )}
            {stage === 2 && (
              <form onSubmit={confirm} className="mt-6 space-y-4">
                {devToken && <div className="rounded-xl border border-[hsl(var(--brand-gold))]/40 bg-[hsl(var(--brand-gold))]/10 p-3 text-sm"><div className="font-semibold">Dev token:</div><div className="font-mono break-all">{devToken}</div></div>}
                <div><Label>Token</Label><Input required value={token} onChange={e => setToken(e.target.value)} /></div>
                <div><Label>New password</Label><Input required type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} /></div>
                <Button type="submit" className="w-full bg-[hsl(var(--brand-navy))]">Update password</Button>
              </form>
            )}
            {stage === 3 && (
              <div className="mt-6"><Button asChild className="w-full bg-[hsl(var(--brand-navy))]"><Link to="/login">Sign in</Link></Button></div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
